<footer>
  <h2 class="sr-only">{{'footer.title' | trans}}</h2>
  <div class="container">
    <div [innerHTML]="footer | safe: 'html'"></div>
  </div>
</footer>
